import { Injectable } from '@angular/core';
import {MsalBroadcastService, MsalService} from "@azure/msal-angular";
import {filter, first, firstValueFrom, race} from "rxjs";
import {Role} from "../enum/role";
import {Project} from "../models/project";
import {ProjectRole} from "../enum/project-role";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {


  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService
  ) { }

  async initialize() {
    await firstValueFrom(this.msalService.initialize());
  }

  async waitForRedirect() {
    await firstValueFrom(this.msalService.handleRedirectObservable());
    return this.isLoggedIn();
  }

  isLoggedIn() {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  isAdmin() {
    return this.userRoles.includes(Role.ADMIN);
  }

  isProjectAdmin(project: Project) {
    if (!this.isLoggedIn()) {
      return false;
    }

    if (this.isAdmin()) {
      return true;
    }

    const upn = this.msalService.instance.getAllAccounts()[0]?.username;
    return project.assignments.find(assignment => assignment.user.email === upn)?.role === ProjectRole.ADMIN;
  }

  logout() {
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();

    // Redirect to logout
    window.location.href = '/';
  }

  get userRoles() {
    return this.msalService.instance.getAllAccounts()[0]?.idTokenClaims?.roles ?? [];
  }
}
